import axios from "axios"
import { BASE_URL } from "src/constants"

export const getToken = async (userId) => {
  return await axios.get(`${BASE_URL}/auth/token/${userId}`)
}
